import { type FC } from 'react';
import cn from 'classnames';
import { cubicBezier, motion } from 'framer-motion';

import { Picture } from '@/components/ui/Picture/Picture';

import { useCurrentLotteryTier } from '../../hooks';

import { imagesList, position } from './config';

import css from './styles.module.scss';

interface ImagesSwiperProps {
  className?: string;
}

const ImagesSwiper: FC<ImagesSwiperProps> = ({ className }) => {
  const currentTicketType = useCurrentLotteryTier();

  return (
    <div className={cn(css.imageSwiper, className)}>
      <motion.div
        initial={position[currentTicketType]}
        animate={position[currentTicketType]}
        transition={{
          ease: cubicBezier(0.34, 1.56, 0.64, 1),
          duration: 0.2,
        }}
        className="absolute top-[20.56%] left-0 h-[65.42%] w-[300%] flex"
      >
        {imagesList.map((props, index) => (
          <div
            key={index}
            className="h-full py-[20px] flex-1 flex items-center justify-center"
          >
            <Picture
              className="h-full aspect-square"
              key={props.alt}
              {...props}
            />
          </div>
        ))}
      </motion.div>
    </div>
  );
};

export { ImagesSwiper };
